/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 2 4 3.553L14.474 7 13 5.602V11h5.398L17 9.526 18.447 8 22 12l-3.553 4L17 14.474 18.398 13H13v5.398L14.474 17 16 18.447 12 22l-4-3.553L9.526 17 11 18.398V13H5.602L7 14.474 5.553 16 2 12l3.553-4L7 9.526 5.601 11H11V5.601L9.526 7 8 5.553z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrow as Arrow };
